
import Vue from 'vue';
import jcxyDialog from "./jcxy-dialog.vue";


let newInstance;

const ConfirmInstance = Vue.extend(jcxyDialog);  // 创建构造函数

const initInstance = () => { // 执行方法后完成挂载
  newInstance = new ConfirmInstance();  // 实例化
  // document.body.appendChild(newInstance.$mount().$el);
  const dom = document.getElementsByClassName('appContent')[0]
  dom.style.position = 'relative'
  dom.appendChild(newInstance.$mount().$el);
  // 实例化后手动挂载，得到$el真实Dom，将其添加到body最后
}

export default options => {
  //导出一个方法，接受配置参数
  if (!newInstance) {
    initInstance(); // 挂载
  }
  Object.assign(newInstance, options);
  // 实例化后newInstance就是一个对象了，所以data内的数据会
  // 挂载到this下，传入一个对象与之合并

  return newInstance.open(vm => {  // 显示弹窗
    newInstance = null;  // 将实例对象清空
  })
}


// WEBPACK FOOTER //
// ./src/components/jcxy-dialog/jcxy-dialog.js